import { useNavigate } from 'react-router';
import { useTheme } from '../ThemeContext';


const BackButton = () => {
    const navigate = useNavigate();
    const { darkMode } = useTheme();
  return (
    <button onClick={() => navigate(-1)}  style={{ marginBottom : '20px', top: '50px', left: '20px', padding: '8px 12px', borderRadius: '4px', backgroundColor: darkMode ? '#333' : '#fff', color: darkMode ? '#000' : '#000', fontWeight: 'bold'  }}>
      Retour
    </button>


  );
};

export default BackButton;